module.exports = __webpack_public_path__ + "static/media/gym5.4f89571e.jpg";